export default "__VITE_ASSET__86662ec7__"